import api from './api';

// 提交简历评估
export const submitEvaluation = async (jdId, resumeText) => {
  try {
    const response = await api.post(`/evaluation`, {
      jd_id: jdId,
      resume_text: resumeText
    });
    return response;
  } catch (error) {
    console.error('提交评估失败:', error.response?.data);
    throw new Error(error.response?.data?.detail || '提交评估失败');
  }
};

// 获取评估状态
export const getEvaluationStatus = async (id) => {
  try {
    const response = await api.get(`/evaluation/${id}/status`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '获取评估状态失败');
  }
};

// 获取评估结果
export const getEvaluationResult = async (id) => {
  try {
    const response = await api.get(`/evaluation/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '获取评估结果失败');
  }
};

// 获取评估记录列表
export const getEvaluationList = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/evaluation?page=${page}&limit=${limit}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '获取评估记录列表失败');
  }
};



// 删除评估记录
export const deleteEvaluation = async (id) => {
  try {
    await api.delete(`/evaluation/${id}`);
    return true;
  } catch (error) {
    console.error('删除评估记录失败:', error);
    throw new Error(error.response?.data?.detail || '删除评估记录失败');
  }
};
